import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Newspaper } from "lucide-react";
import { api } from "../lib/api";
import { BlogCard } from "./BlogCard";

const BlogSection = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog?limit=3").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section id="blog" className="py-24 relative" data-testid="blog-section">
      <div className="absolute inset-0 circuit-dots opacity-30 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-emerald-300/80 inline-flex items-center gap-2">
              <Newspaper className="w-4 h-4" /> Blog & Συμβουλές
            </div>
            <h2 className="mt-2 text-3xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-tight">
              Τεχνολογία & <span className="text-emerald-400">χρήσιμες συμβουλές</span>
            </h2>
            <p className="mt-4 text-emerald-50/70 max-w-2xl">
              Οδηγοί και νέα της τεχνολογίας από το εργαστήριό μας στη Λαμία, για να κρατάτε τις συσκευές σας σε φόρμα.
            </p>
          </div>
          <Link
            to="/blog"
            data-testid="blog-view-all-link"
            className="btn-outline rounded-md px-4 py-2.5 text-sm inline-flex items-center gap-2 self-start md:self-auto"
          >
            Όλα τα άρθρα <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {posts.map((p) => (
            <BlogCard key={p.id} post={p} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
